import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How quickly can we implement True Wellness?",
    answer: "Most organizations are fully onboarded within 2 weeks. We handle all setup, employee communications, and training.",
  },
  {
    question: "Is this covered by our insurance?",
    answer: "True Wellness operates outside insurance, which allows us to offer transparent, affordable pricing. Many employers add this as a voluntary benefit or cover part/all of the cost.",
  },
  {
    question: "What if an employee doesn't qualify medically?",
    answer: "Our physicians review each case individually. If GLP-1s aren't appropriate, we can discuss alternative peptide therapies or refer to other resources.",
  },
  {
    question: "How do you ensure privacy and HIPAA compliance?",
    answer: "We're fully HIPAA compliant. Employee health information is never shared with employers. You only receive aggregated, anonymized program metrics.",
  },
  {
    question: "Can we customize the plan for our organization?",
    answer: "Absolutely. We can adjust coverage levels, add specific services, or create custom wellness challenges for your team.",
  },
  {
    question: "What kind of reporting do you provide?",
    answer: "Monthly dashboards show participation rates, average weight loss, engagement metrics, and projected ROI. Quarterly business reviews included with all plans.",
  },
  {
    question: "What community support is available?",
    answer: "Employees get access to monthly wellness events, peer support groups, and community challenges that drive accountability and better outcomes.",
  },
  {
    question: "What's the employee experience like?",
    answer: "2-minute health assessment, same-day physician approval in most cases, medication ships within 48 hours, monthly telehealth check-ins, and optional community events.",
  },
];

const EmployerFAQ = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-[#0D1B2A]/5 to-[#1B3A4B]/10">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white rounded-lg shadow-sm border-0 px-6 data-[state=open]:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default EmployerFAQ;
